export enum FilterState {
  PEDDING = 'pedding',
  DONE = 'done',
  ERROR = 'error',
  SUCCESS = 'success',
}
